import api from './axios';

export const listar = (incluirIgnorados = false) =>
  api.get('/quarentena/', { params: { incluir_ignorados: incluirIgnorados } });

export const promover = (id) => api.post(`/quarentena/${id}/promover`);
export const ignorar = (id) => api.post(`/quarentena/${id}/ignorar`);
export const excluir = (id) => api.delete(`/quarentena/${id}`);
